/**
 * HeaderSearchSlot — Bloco central do header (pesquisa global + botão "+")
 *
 * Componente único reutilizado por TODOS os layouts do tenant para garantir
 * que a pesquisa global (contatos + clientes) e o botão de criação rápida
 * apareçam de forma idêntica em qualquer tela, evitando divergência entre
 * os headers duplicados de cada layout.
 *
 * Visibilidade: a partir de `md`. No mobile a busca/"+" continuam disponíveis
 * pelo menu overflow e pelo botão "+" do bloco de ações.
 *
 * Atalhos: monta `useQuickCreateShortcuts`, que habilita os atalhos globais
 * de criação rápida (Alt+tecla em qualquer lugar; tecla simples fora de
 * campos de texto) em todas as telas do tenant.
 *
 * RELEASE: 2026-10-04 v1.3.0 - Move o atalho fixo para junto do avatar do usuário.
 * RELEASE: 2026-10-04 v1.2.0 - Exibe "Minhas tarefas" após o botão "+" quando fixado.
 * RELEASE: 2026-08-06 v1.1.0 - Monta os atalhos globais do Quick Create.
 * RELEASE: 2026-08-06 v1.0.0 - Criação.
 */

import { GlobalSearch } from '@/components/layouts/GlobalSearch';
import { QuickCreateButton } from '@/components/quick-create/QuickCreateButton';
import { useQuickCreateShortcuts } from '@/hooks/useQuickCreateShortcuts';

export function HeaderSearchSlot() {
  // Atalhos globais (não dependem do popover estar aberto).
  useQuickCreateShortcuts();

  return (
    <div className="hidden md:flex flex-1 min-w-0 items-center justify-center gap-2">
      <div className="w-full max-w-[520px] min-w-0">
        <GlobalSearch />
      </div>
      <QuickCreateButton variant="round" />
    </div>
  );
}

